import { isDefined } from '@sgme/fp';
import { MinMaxHint } from 'components/common-form/components/MinMaxHint';
import { useMinMaxText } from 'components/common-form/hooks/useMinMaxText';
import { FC, useState } from 'react';
import { ContentPosition } from 'types/content-position';

interface ComponentProps {
  onBlur?: (value?: number) => void;
  onChange?: (value?: number) => void;
  onFocus?: () => void;
  value?: Nullable<number>;
  placeholder?: string;
  unitsPosition?: Extract<ContentPosition, 'start' | 'end'>;
}
type Props<T extends ComponentProps> = T & {
  Component: FC<T>;
  minimum?: number;
  maximum?: number;
  unit?: string;
};
export function WithMinMax<T extends ComponentProps>(props: Props<T>) {
  const [hasFocus, setHasFocus] = useState(false);
  const [inputValue, setInputValue] = useState(props.value);
  const placeholder = useMinMaxText({ min: props.minimum, max: props.maximum, unit: props.unit });
  const hasMinMax = isDefined(props.minimum) && isDefined(props.maximum);
  return (
    <>
      <props.Component
        {...props}
        placeholder={placeholder}
        onFocus={() => {
          props.onFocus?.();
          setHasFocus(true);
        }}
        onBlur={
          hasMinMax
            ? v => {
                props.onBlur?.(v);
                setHasFocus(false);
              }
            : props.onBlur
        }
        onChange={
          hasMinMax
            ? v => {
                props.onChange?.(v);
                setInputValue(v);
              }
            : props.onChange
        }
      ></props.Component>
      {hasFocus && isDefined(inputValue) && hasMinMax && isDefined(props?.value) && (
        <MinMaxHint value={inputValue} min={props.minimum as number} max={props.maximum as number} unit={props.unit} />
      )}
    </>
  );
}
